var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scope.row[_vm.config.prop])?_c('div',[_c('a',{attrs:{"href":_vm.scope.row[_vm.config.prop]}},[_vm._v(_vm._s(_vm.scope.row[_vm.config.prop]))])]):_c('div',[_vm._v(" 无对应字段~ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }